import React, { useEffect, useState } from "react";
import { Badge, Card, CardBody, Col, Container, Input, Label, Row, Spinner } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { loadMesAchats } from "../encheres/enchereService";
import { loadFerrailleurs } from "../reseau/reseauService";

const firstVehiclePhoto = (enchere) => (enchere?.vehiculePhotos || []).find((photo) => photo?.path)?.path;

function MesAchatsPage() {
  const [ferrailleurs, setFerrailleurs] = useState([]);
  const [ferrailleurId, setFerrailleurId] = useState("");
  const [achats, setAchats] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadFerrailleurs().then((response) => {
      const list = response?.data?.body || [];
      setFerrailleurs(list);
      if (list[0]?.id) setFerrailleurId(String(list[0].id));
    });
  }, []);

  useEffect(() => {
    if (ferrailleurId) {
      setLoading(true);
      loadMesAchats(ferrailleurId)
        .then((response) => setAchats(response?.data?.body || []))
        .finally(() => setLoading(false));
    }
  }, [ferrailleurId]);

  return (
    <div className="page-content auction-page">
      <Container fluid>
        <Breadcrumbs title="Mes achats" breadcrumbItems={[{ title: "Férailleurs", link: "#" }, { title: "Mes achats", link: "#" }]} />
        <Card className="mb-4">
          <CardBody>
            <Row className="g-3 align-items-end">
              <Col lg={7}>
                <h4 className="mb-1">Mes achats</h4>
                <p className="text-muted mb-0">Historique des enchères attribuées au férailleur.</p>
              </Col>
              <Col lg={5}>
                <Label>Profil férailleur</Label>
                <Input type="select" value={ferrailleurId} onChange={(event) => setFerrailleurId(event.target.value)}>
                  {ferrailleurs.map((ferrailleur) => <option key={ferrailleur.id} value={ferrailleur.id}>{ferrailleur.nom}</option>)}
                </Input>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {loading ? <div className="text-center py-5"><Spinner color="primary" /></div> : (
          <Row className="g-3">
            {achats.map((achat) => (
              <Col xl={4} md={6} key={achat.id}>
                <Card className="h-100 auction-card">
                  <CardBody>
                    {firstVehiclePhoto(achat) && (
                      <img className="auction-vehicle-photo mb-3" src={firstVehiclePhoto(achat)} alt={achat.vehiculeLabel || achat.titre || "Vehicule"} />
                    )}
                    <Badge color="success" className="mb-3">Achat confirmé</Badge>
                    <h5>{achat.titre || achat.vehiculeLabel}</h5>
                    <p className="text-muted">{achat.vehiculeLabel || "Vehicule"}</p>
                    <div className="d-flex justify-content-between border-top pt-3">
                      <span>Prix final</span>
                      <strong>{achat.prixFinal || achat.prixDepart || "-"} MAD</strong>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
            {!achats.length && <Col><Card><CardBody className="text-center py-5 text-muted">Aucun achat enregistré.</CardBody></Card></Col>}
          </Row>
        )}
      </Container>
    </div>
  );
}

export default MesAchatsPage;
